<template>
  <!-- eslint-disable -->
  <div class="p-2 h-full" v-loading="!showContent">
    <div v-if="showContent" class="text-center font-bold mb-3 text-sm">
      <h6 class="my-4" v-if="printable">{{title}}</h6>
      <h4 class="my-4" v-else>{{title}}</h4>
    </div>

    <div
      v-if="showContent"
      id="rawChartWrapper"
      class="w-full flex flex-col space-y-2 justify-between bg-white absolute"
      style="right: -3000px;"
      :height="height"
    >
      <template v-for="(item, index) of rawChartdata">
        <LineChart
          class="w-full"
          id="chartRenderer"
          ref="chartRenderer"
          :chart-data="item"
          :options="rawChartOptions"
          :height="height"
          :class="hideChart() ? 'hidden' : ''"

          @rawChart="setChartBaseSource($event, index)"
          v-if="chartType === 'line'"
        />
        <BarChart
          class="w-full"
          id="chartRenderer"
          ref="chartRenderer"
          :chart-data="item"
          :options="rawChartOptions"
          :height="height"
          :class="hideChart() ? 'hidden' : ''"

          @rawChart="setChartBaseSource($event, index)"
          v-if="chartType === 'bar'"
        />
      </template>
    </div>
    <div
      v-if="showContent"
      id="chartWrapper"
      class="w-full flex space-x-0 space-y-2 lg:space-x-2 lg:space-y-0 justify-between bg-white "
    >
      <div class="w-4/5 h-full flex justify-items-stretch p-2">
        <LineChart
          class="w-full"
          id="chartRenderer"
          ref="chartRenderer"
          :chart-data="chartdata"
          :options="options"
          :height="height"
          :class="hideChart() ? 'hidden' : ''"

          v-if="chartType === 'line'"
        />
        <BarChart
          class="w-full"
          id="chartRenderer"
          ref="chartRenderer"
          :chart-data="chartdata"
          :options="options"
          :height="height"
          :class="hideChart() ? 'hidden' : ''"

          v-if="chartType === 'bar'"
        />
      </div>
      <div class="w-1/5 flex flex-col space-y-2 font-regular text-left text-gray-900 overflow-y-scroll scrollbar-thin scrollbar-thumb-blue-700 scrollbar-track-blue-300 hover:scrollbar-thumb-green-700 " style="height: 30em">

          <div
            v-for="(item, index) in chartdata.datasets"
            :key="index"
            class="w-full text-left flex py-2"
          >
            <div class="border border-transparent rounded-full h-3 w-3" :style="`background-color: ${item.backgroundColor}`"></div>
            <div class="pl-2 w-full flex justify-between">
              <div class="font-bold text-xs">{{ item.label }}{{ item.unit }}</div>
            </div>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
import CurrentValue from '@/components/widget/CurrentValue'
import LineChart from '@/components/Chart/Line'
import BarChart from '@/components/Chart/Bar'
import * as d3 from 'd3-scale-chromatic'
import interpolateColors from '@/helpers/chromaticColors'
import formattedValue from '@/helpers/formattedValue'
import CustomTooltip from '@/components/Chart/CustomTooltip'

export default {
  components: {
    LineChart,
    BarChart,
    CurrentValue
  },
  props: {
    title: {
      type: String
    },
    chartType: {
      type: String,
      default: () => 'line'
    },
    reportData: {
      type: Array
    },
    printable: {
      type: Boolean,
      default: () => false
    },
    unit: {
      type: String,
      default: () => ''
    },
    period: {
      type: String,
      default: () => ''
    },
    colorScheme: {
      type: Array,
      default: () => []
    },
    decimalSeparator: {
      type: Number,
      default: () => 2
    }
  },
  data() {
    return {
      height: 350,
      chartdata: {
        labels: [],
        datasets: []
      },
      rawChartdata: {},
      rawChartBase64: {},
      options: {
        layout: {
          padding: {
            top: 10
          }
        },
        plugins: {
          datalabels: {
            // hide datalabels for all datasets
            display: false
          }
        },
        responsive: true,
        legend: {
          display: false
        },
        title: {
          display: false
        },
        // tooltips: false,
        hover: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                zeroLineColor: 'transparent'
              },
              ticks: {
                padding: 20,
                fontColor: 'rgba(0,0,0,0.5)',
                fontStyle: 'bold'
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true
              },
              display: true,
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: ''
              }
            }
          ]
        },
        tooltips: {
          enabled: false,
          mode: 'index',
          custom: CustomTooltip
        }
      },
      rawChartOptions: {
        layout: {
          padding: {
            top: 10
          }
        },
        plugins: {
          datalabels: {
            // hide datalabels for all datasets
            display: false
          }
        },
        responsive: true,
        legend: {
          display: true,
          position: 'bottom'
        },
        title: {
          display: false
        },
        // tooltips: false,
        hover: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                zeroLineColor: 'transparent'
              },
              ticks: {
                padding: 20,
                fontColor: 'rgba(0,0,0,0.5)',
                fontStyle: 'bold'
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true
              },
              display: true,
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: ''
              }
            }
          ]
        },
        tooltips: {
          mode: 'index',
          intersect: false
        }
      },
      showContent: false
    }
  },
  mounted() {
    this.setChartData()
  },
  methods: {
    setChartData(reportData) {
      var _this = this

      // set reportData
      if (!reportData) {
        reportData = this.reportData
      }

      this.showContent = false

      // reset chart data
      this.chartdata = {
        labels: [],
        datasets: []
      }

      // get chart color
      var chartColors = this.randomColors(reportData.length)
      var i = 0
      for (var sensor of reportData) {
        var labelName = sensor.FormulaData.GroupName
        var groupNameAllowed =
          reportData.filter(
            (x) => x.FormulaData.GroupName === sensor.FormulaData.GroupName
          ).length > 1

        if (groupNameAllowed) {
          labelName = sensor.FormulaData.VarLabel
        } else if (!labelName) {
          labelName = sensor.FormulaData.LabelGroupName
        }

        // set dateset
        this.chartdata.datasets.push({
          fill: false,
          label: labelName,
          backgroundColor: chartColors[i],
          borderColor: chartColors[i],
          data: sensor.HistoricalValue.map((x) => x.DecimalVal),
          pointRadius: 0,
          borderWidth: 2
        })

        // chart labels
        this.chartdata.labels = sensor.HistoricalValue.map((x) =>
          formattedValue.readableDate(x.Timestamp)
        )
        i++
      }

      // chart options
      this.options.scales.yAxes[0].scaleLabel.labelString = `${this.unit}`
      this.options.tooltips.callbacks = {
        label: function (tooltipItem, data) {
          var formattedVal = formattedValue.content(
            tooltipItem.yLabel,
            _this.unit,
            _this.decimalSeparator
          )
          var label = data.datasets[tooltipItem.datasetIndex].label
          return `${label}: ${formattedVal}`
        }
      }

      // raw chart options
      this.rawChartOptions.scales.yAxes[0].scaleLabel.labelString = `${this.unit}`
      this.rawChartOptions.tooltips.callbacks = {
        label: function (tooltipItem, data) {
          var formattedVal = formattedValue.content(
            tooltipItem.yLabel,
            _this.unit,
            _this.decimalSeparator
          )
          var label = data.datasets[tooltipItem.datasetIndex].label
          return `${label}: ${formattedVal}`
        }
      }

      // set multiple raw chart data
      this.setMultipleRawChartData(this.chartdata.datasets)
      this.showContent = true
    },
    setMultipleRawChartData(datasets) {
      var grouppedDataSet = this.splitArray(datasets, 10)
      var key = 0

      for (var data of grouppedDataSet) {
        // get chart color
        var chartColors = this.randomColors(data.length)

        this.rawChartdata[key] = {
          labels: this.chartdata.labels,
          datasets: data.map(function (item, key) {
            return {
              fill: false,
              label: item.label,
              backgroundColor: chartColors[key],
              borderColor: chartColors[key],
              data: item.data,
              pointRadius: 0,
              borderWidth: 2
            }
          })
        }

        key++
      }
    },
    randomColors(length) {
      const randomColors = interpolateColors(length, d3.interpolateRainbow, {
        colorStart: 0,
        colorEnd: 1,
        useEndAsStart: true
      })

      if (this.colorScheme.length > 0) {
        return this.colorScheme
      } else {
        return randomColors
      }
    },
    splitArray(arr, len) {
      var chunks = []
      var i = 0
      var n = arr.length

      while (i < n) {
        chunks.push(arr.slice(i, (i += len)))
      }

      return chunks
    },
    hideChart() {
      return this.rawChart !== '' && this.printable
    },
    setChartBaseSource(value, index) {
      if (value) {
        this.rawChartBase64[index] = value
        this.$emit('rawChart', this.rawChartBase64)
      }
    }
  },
  watch: {
    reportData: {
      deep: true,
      handler(val) {
        if (val) {
          this.setChartData(val)
        }
      }
    }
  }
}
</script>
